import React from 'react';

import { IServerOrder } from '@rbi-ctg/menu';
import { GoogleGeolocationLibraryLoader } from 'components/google-geolocation-library-loader';
import DeliveryConfirmation from 'pages/order-confirmation/delivery/delivery-confirmation';

import { StyledModal } from './details-modal.styled';

const IsEnRouteModal: React.FC<{
  serverOrder: IServerOrder;
  onModalDismiss: (orderId: string) => void;
}> = ({ serverOrder, onModalDismiss }) => {
  return (
    <StyledModal
      data-testid="is-en-route-modal"
      onDismiss={() => onModalDismiss('')}
      mParticleEventData={{
        modalAppearanceEventMessage: 'Order Details',
      }}
    >
      <GoogleGeolocationLibraryLoader>
        <DeliveryConfirmation serverOrder={serverOrder} isInsideModal />
      </GoogleGeolocationLibraryLoader>
    </StyledModal>
  );
};

export default IsEnRouteModal;
